module.exports = __webpack_public_path__ + "static/postmark-91ab8ba194bbf9997d7e5d9eda044cc2.jpg";